import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import { getTemplatePayrollPercent } from "../../Redux/Actions/salarycalculation";
import { useDispatch, useSelector } from "react-redux";
//windowsize
import useWindowSize from "../../Component/use-window-size";
import { initialState } from "../../Redux/Reducers/salaryCalculationTaxFigures";

const TemplatePayrollTax = ({ setHeadingFocused }) => {
  //get current windowsize
  const size = useWindowSize();
  const [cardFocused, setCardFocused] = useState(false);
  const [input, setInput] = useState(initialState.templatePayrollPercent);
  const dispatch = useDispatch();

  const templatePayroll = useSelector(
    (state) => state.salaryCalculation.templatePayroll
  );
  const sizeForMobile = useSelector((state) => state.sizeForMobile.size);

  function handleChange(e) {
    e.preventDefault();
    setInput(parseFloat(e.target.value) || "");
  }

  useEffect(() => {
    dispatch(getTemplatePayrollPercent(input));
  }, [dispatch, input]);

  const card = {
    backgroundColor: cardFocused ? "rgb(255 215 215)" : "rgb(255 242 242)",
    transition: "0.5s",
    width: "100%",
  };
  const heading = {
    color: cardFocused ? "#000000" : "#777",
    overflow: "hidden",
    whiteSpace: "nowrap",
    cursor: "default",
  };
  const inputElement = {
    color: cardFocused ? "#000000" : "#777",
  };
  const outputElement = {
    backgroundColor: cardFocused ? "rgb(255 215 215)" : "rgb(255 242 242)",
    borderColor: cardFocused ? "rgb(255 215 215)" : "rgb(255 242 242)",
    transition: "0.5s",
    color: cardFocused ? "#000000" : "#777",
    cursor: "default",
    overflow: "hidden",
    whiteSpace: "nowrap",
  };

  return (
    <>
      {size.width < sizeForMobile ? (
        <Row
          className="g-0 mt-2 m-auto rounded-3"
          style={card}
          onFocus={() => setCardFocused(true)}
          onBlur={() => setCardFocused(false)}
        >
          <Col
            xs={40}
            className="p-2 d-flex align-items-center justify-content-center text-center responsive-fontsize"
            style={heading}
          >
            Egenavgifter (schablon)
          </Col>

          <Col xs={17} className="offset-0 p-2" style={{ padding: "0px" }}>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <label className="label-mobile-percent">%</label>
              <input
                type="text"
                className="form-control text-center"
                name="percent"
                style={inputElement}
                defaultValue={input}
                autoComplete="off"
                maxLength="5"
                onChange={(e) => handleChange(e)}
                onFocus={(e) => setHeadingFocused(e.target.name)}
                onBlur={() => setHeadingFocused("")}
              />
            </div>
          </Col>

          <Col xs={20} className="p-2" style={{ padding: "0px" }}>
            <output className="form-control text-center" style={outputElement}>
              -{" "}
              {templatePayroll > 0 || templatePayroll < 0
                ? Math.round(templatePayroll)
                : 0}
            </output>
          </Col>
        </Row>
      ) : (
        <Row
          className="g-0 mt-2 m-auto rounded-3"
          style={card}
          onFocus={() => setCardFocused(true)}
          onBlur={() => setCardFocused(false)}
        >
          <Col
            xs={17}
            className="p-2 d-flex align-items-center justify-content-center text-center responsive-fontsize"
            style={heading}
          >
            Egenavgifter (schablon)
          </Col>

          <Col xs={5} className="offset-11 p-2" style={{ padding: "0px" }}>
            <input
              type="text"
              className="form-control text-center"
              name="percent"
              style={inputElement}
              defaultValue={input}
              autoComplete="off"
              maxLength="5"
              onChange={(e) => handleChange(e)}
              onFocus={(e) => setHeadingFocused(e.target.name)}
              onBlur={() => setHeadingFocused("")}
            />
          </Col>

          <Col xs={7} className="p-2" style={{ padding: "0px" }}>
            <output className="form-control text-center" style={outputElement}>
              -{" "}
              {templatePayroll > 0 || templatePayroll < 0
                ? Math.round(templatePayroll)
                : 0}
            </output>
          </Col>
        </Row>
      )}
    </>
  );
};
export default TemplatePayrollTax;
